import type { AxiosRequestConfig } from "axios";
import { OrderReturn, TissueTrackingInfo, AddOrderInfo, OrderFulfillmentInfo, TrackingRegistrationRequest, ProductReturnApprovalRequest, ProductReturnPendingRequest, OrderItemsPriceUpdateRequest } from "../redux/slice/order/OrderSlice";
import { InterceptorOption } from "../types/CommonTypes";
import { ADD_TISSUETRACKING_URL, APPROVE_PRODUCT_RETURN_URL, CANCEL_ORDER, CREATE_ORDER, CREATE_ORDER_ANCILLARY_ORDER, CREATE_OUTSIDE_ORDER, EDIT_AGENCY_PRODUCT_COMMISSION_BILLING_URL, EDIT_COMMISSION_RATE_URL, GET_DOCUMENT_URL, GET_DOCUMENTS_URL, GET_ORDER_BY_PATIENT_ID, GET_ORDER_ITEMS_BY_CLAIM_ID_URL, GET_ORDER_ITEMS_BY_ID, GET_ORDER_ITEMS_BY_INVOICE_ID_URL, GET_ORDER_TRACKING_LOGS, GET_REALTIME_TRACKINFO, PREVIEW_CMS_1500_FORM, PREVIEW_EVALUATION_PDF, PREVIEW_PPACKAGE_PDF,PREVIEW_PRESCRIPTION_PDF,PREVIEW_PROOFOFDELIVERY_PDF,PREVIEW_SALES_INVOICE_PDF, REGISTER_WEBHOOK, RETURN_ORDER, SEARCH_ORDER, UPDATE_ORDER, UPDATE_OUTSIDE_ORDER, REJECT_PRODUCT_RETURN_URL, GET_PRODUCT_RETURN_AUDIT_URL, GET_PLACE_ORDER_CHECK_API, FETCH_PRACTICE_BY_USER_ROLE_IVR_ORDER, FETCH_ORDER_BY_ID ,UPDATE_ORDER_ITEMS_PRICE, VERIFY_ORDER_TRACKING_LOGS, GET_OUTSIDE_ORDER_DETAIL, PENDING_PRODUCT_RETURN_URL } from "./URL";
import { http } from "./http";

export const orderCreate = async (data: AddOrderInfo | null) => {
    try {
        const response = await http.post(CREATE_ORDER, data);
        return response
    } catch (error) {
        throw error;
    }
}

export const createOutsideOrder = async (data: any) => {
    try {
        const response = await http.post(CREATE_OUTSIDE_ORDER, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateOutsideOrder = async (data: any) => {
    try {
        const response = await http.post(UPDATE_OUTSIDE_ORDER, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getOutsideOrderDetail = async (orderId: number) => {
  try {
    const response = await http.get(`${GET_OUTSIDE_ORDER_DETAIL}?orderId=${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
}
// CS-793 Ancillary Order Changes
export const ancilaryOrderCreate = async (data:any | null) => {
    try {
        const response = await http.post(CREATE_ORDER_ANCILLARY_ORDER, data);
        return response
    } catch (error) {
        throw error;
    }
}
//

export const orderUpdate = async (data: OrderFulfillmentInfo | null, interceptorOption: InterceptorOption) => {
    try {
        const response = await http.post(UPDATE_ORDER, data, undefined, interceptorOption);
        return response
    } catch (error) {
        throw error;
    }
}

export const getOrderItemsById = async (orderId: number) => {
    try {
        const response = await http.get(`${GET_ORDER_ITEMS_BY_ID}?orderId=${orderId}`);
        return response
    } catch (error) {
        throw error;
    }
}

export const returnOrder = async (data: OrderReturn | null) => {
    try {
        const response = await http.post(RETURN_ORDER, data);
        return response
    } catch (error) {
        throw error;
    }
}

//CS-1164 START
export const approveProductReturn = async (data: ProductReturnApprovalRequest) => {
    try {
        const response = await http.post(APPROVE_PRODUCT_RETURN_URL, data);
        return response
    } catch (error) {
        throw error;
    }
}
//CS-1164 END

// CS-1164 - Reject Return
export const rejectProductReturn = async (data: ProductReturnApprovalRequest) => {
    try {
        const response = await http.post(REJECT_PRODUCT_RETURN_URL, data);
        return response
    } catch (error) {
        throw error;
    }
}

// Mark Product Return as Pending
export const pendingProductReturn = async (data: ProductReturnPendingRequest) => {
    try {
        const response = await http.post(PENDING_PRODUCT_RETURN_URL, data);
        return response
    } catch (error) {
        throw error;
    }
}

export const searchOrder = async (data: any, headers: Record<string, string>) => {
    try {
      const response = await http.post(SEARCH_ORDER, data, {headers: {...headers}});
      return response;
    } catch (error) {
      throw error;
    }
  };

export const tissueTracking = async (data: TissueTrackingInfo, interceptorOption: InterceptorOption) => {
    try {
        const response = await http.post(ADD_TISSUETRACKING_URL, data, undefined, interceptorOption);
        return response;
    } catch (error) {
        throw error;
    }

};

export const editProductCommissionFromBilling = async (data: any) => {
    try {
        const response = await http.post(EDIT_AGENCY_PRODUCT_COMMISSION_BILLING_URL, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const editCommissionRate = async (data: any, skipLoader: boolean = false) => {
    try {
        const response = skipLoader
            ? await http.post(EDIT_COMMISSION_RATE_URL, data, { headers: { "x-skip-loader": "true" } })
            : await http.post(EDIT_COMMISSION_RATE_URL, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getOrderDocumentByDocumentId = async (orderDocumentId: number) => {
    try {
      const response = await http.get(`${GET_DOCUMENT_URL}/${orderDocumentId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // CS - 922 
export const previewPackagingPDF = async (orderId: number) => {
    try {
      const response = await http.get(`${PREVIEW_PPACKAGE_PDF}/${orderId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
//

// CS - 731 - Start
export const previewSalesInvoicePDF = async (orderId: number) => {
    try {
      const response = await http.get(`${PREVIEW_SALES_INVOICE_PDF}/${orderId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
//
// CS - 936 - Start
export const previewProofOfDeliveryPDF = async (orderId: number) => {
    try {
      const response = await http.get(`${PREVIEW_PROOFOFDELIVERY_PDF}/${orderId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
//
// CS - 927 - Start
export const previewEvaltionFormPDF = async (orderId: number) => {
    try {
      const response = await http.get(`${PREVIEW_EVALUATION_PDF}/${orderId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
//
// CS - 926 - Start
export const previewPrescription = async (orderId: number) => {
    try {
      const response = await http.get(`${PREVIEW_PRESCRIPTION_PDF}/${orderId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
//
// CS - 934 
export const previewCMS1500 = async (orderId: number) => {
    try {
      const response = await http.get(`${PREVIEW_CMS_1500_FORM}/${orderId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
//
export const getOrderDocumentsByDocumentIds = async (
  orderDocumentIds: number[],
  config?: AxiosRequestConfig
) => {
  try {
    const response = await http.get(`${GET_DOCUMENTS_URL}/${orderDocumentIds}`, config);
    return response;
  } catch (error) {
    throw error;
  }
};
    
export const getProductReturnAudit = async (productReturnId: number) => {
    try {
        const response = await http.get(`${GET_PRODUCT_RETURN_AUDIT_URL}/${productReturnId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

  export const orderCancel = async (orderId: number) => {
    try {
        const response = await http.post(`${CANCEL_ORDER}/${orderId}`);
        return response
    } catch (error) {
        throw error;
    }
}

export const getOrderTrackingLogsData = async (orderId: number, trackingNumber: string) => {
  try {
    const response = await http.get(`${GET_ORDER_TRACKING_LOGS}?orderId=${orderId}&trackingNumber=${trackingNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const register17TrackWebhook = async (data: TrackingRegistrationRequest[]) => {
  try {
    const response = await http.post(`${REGISTER_WEBHOOK}`, data);
    return response
  } catch (error) {
    throw error;
  }
}

export const getRealTimeTrackingInfo = async (trackingNumber: string, carrier: number, orderId: number) => {
  try {
    const response = await http.post(`${GET_REALTIME_TRACKINFO}?trackingNumber=${trackingNumber}&carrier=${carrier}&orderId=${orderId}`);
    return response
  } catch (error) {
    throw error;
  }
}

export const getOrderByPatient = async (patientId: number) => {
  try {
      const response = await http.get(`${GET_ORDER_BY_PATIENT_ID}?patientId=${patientId}`);
      return response
  } catch (error) {
      throw error;
  }
}

export const getOrderItemsByInvoice = async (invoiceId: number) => {
    try {
        const response = await http.get(`${GET_ORDER_ITEMS_BY_INVOICE_ID_URL}?invoiceId=${invoiceId}`);
        return response
    } catch (error) {
        throw error;
    }
}

export const getOrderItemsByClaim = async (claimId: number) => {
    try {
        const response = await http.get(`${GET_ORDER_ITEMS_BY_CLAIM_ID_URL}?claimId=${claimId}`);
        return response
    } catch (error) {
        throw error;
    }
}

//CS-1534 - Provider phase 2 new api service 

export const getPlaceOrderCheckApi = async (practiceId: number , providerId:number) => {
    try {
        const response = await http.get(`${GET_PLACE_ORDER_CHECK_API}?practiceId=${practiceId}&providerId=${providerId}`);
        return response
    } catch (error) {
        throw error;
    }
}


export const fetchPracticesByUserRoleOrder = async (isActivePracticeOnly: boolean, headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_PRACTICE_BY_USER_ROLE_IVR_ORDER}?isActivePracticeOnly=${isActivePracticeOnly}`, {
            headers: { ...headers }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getOrderById = async (orderId: number, isSaveAuditLog: boolean) => {
  try {
    const response = await http.get(`${FETCH_ORDER_BY_ID}?orderId=${orderId}&isSaveAuditLog=${isSaveAuditLog}`);
    return response;
  } catch (error) {
    throw error;
  }
};

//CS-1560 - Update Order Items Price
export const updateOrderItemsPriceApi = async (data: OrderItemsPriceUpdateRequest) => {
  try {
    const response = await http.post(UPDATE_ORDER_ITEMS_PRICE, data);
    return response;
  } catch (error) {
    throw error;
  }
}

export const verifyOrderTrackingLogsData = async (trackingNumber: string) => {
  try {
    const response = await http.get(`${VERIFY_ORDER_TRACKING_LOGS}?trackingNumber=${trackingNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}